import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../../../store';
import { actionCreators as UserActionCreators, UserState } from '../../../../store/User';
import { BaseSectionsContainer, BaseSectionsContainerProps } from './BaseSectionsContainer';
import { actionCreators as UserInterfaceActionCreators, UserInterfaceState } from '../../../../store/UserInterfaceStore';
import { withSectionsSettings } from '../withSectionsSettings';

export interface StateProps {
    user: UserState;
    userInterface: UserInterfaceState;
}

export type ActionProps = {
    userActions: typeof UserActionCreators;
    userInterfaceActions: typeof UserInterfaceActionCreators;
}

export type SectionsContainerProps = Omit<BaseSectionsContainerProps, keyof (ActionProps & StateProps)>
type Props = SectionsContainerProps & ActionProps & StateProps & RouteComponentProps<{}>;

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        userActions: bindActionCreators(UserActionCreators, dispatch),
        userInterfaceActions: bindActionCreators(UserInterfaceActionCreators, dispatch)
    };
}

function mapStateToProps(state: ApplicationState, ownProps?: SectionsContainerProps): StateProps {
    return {
        user: state.user,
        userInterface: state.userInterface
    }
}

export default withSectionsSettings<SectionsContainerProps>(withRouter(connect(mapStateToProps, mergeActionCreators)((props: Props) => <BaseSectionsContainer
    {...props}
    isExpanded={props.user.preferences.expandSecondSidebar?.[props.entityType!]}
    onExpand={(expanded) => {
        props.entityType && props.userActions.updateSecondSidebarPreferences(props.entityType, expanded);
    }}
/>)));